import script from "./CasesSuspended.vue?vue&type=script&setup=true&lang=ts"
export * from "./CasesSuspended.vue?vue&type=script&setup=true&lang=ts"

import "./CasesSuspended.vue?vue&type=style&index=0&id=3f44d135&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f44d135"]])

export default __exports__